var map = {
	"./add.svg": 7832,
	"./ask.svg": 92642,
	"./askpaper.svg": 72520,
	"./banner.svg": 35969,
	"./book.svg": 12692,
	"./catalog.svg": 7628,
	"./clock.svg": 81835,
	"./comment.svg": 96702,
	"./course.svg": 9276,
	"./dataquery.svg": 53813,
	"./down.svg": 43211,
	"./excel.svg": 35772,
	"./feedback.svg": 51306,
	"./help.svg": 54594,
	"./home.svg": 41342,
	"./id.svg": 74068,
	"./idea.svg": 90178,
	"./img.svg": 88504,
	"./kpi.svg": 7475,
	"./learn.svg": 81579,
	"./metting.svg": 2351,
	"./my.svg": 88789,
	"./org.svg": 96663,
	"./plan.svg": 23914,
	"./poster.svg": 71376,
	"./press.svg": 58880,
	"./raise.svg": 31229,
	"./ring.svg": 60869,
	"./run.svg": 54666,
	"./setting.svg": 20005,
	"./sms.svg": 73714,
	"./station.svg": 8005,
	"./tag.svg": 40133,
	"./task.svg": 29584,
	"./up.svg": 80868,
	"./upload.svg": 95848,
	"./user.svg": 94218,
	"./users.svg": 49077,
	"./walk.svg": 64236,
	"./word.svg": 88571,
	"./write.svg": 57416,
	"./write2.svg": 17130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;